import '../vendor';

import '../general/ofi';
import '../general/tooltip';

import './game-index/game-filters';
import './game-index/game-filter';
import './game-index/game-select';


// WEBPACK FOOTER //
// ./src/js/pages/game-index.js